var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 244.916,
    height: 48.113,
    viewBox: "0 0 244.916 48.113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13 51)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(13 -51)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M183.31,58.071l1.361-3.016a10.156,10.156,0,0,0,5.706,1.791c2.371,0,3.335-.792,3.335-1.856,0-3.224-10.055-1.01-10.055-7.437,0-2.937,2.371-5.373,7.286-5.373a11.637,11.637,0,0,1,6.007,1.53l-1.236,3.063a9.787,9.787,0,0,0-4.793-1.358c-2.371,0-3.288.888-3.288,1.974,0,3.188,10.059.989,10.059,7.34,0,2.891-2.4,5.373-7.34,5.373a12.332,12.332,0,0,1-7.043-2",
    transform: "translate(-117.645 -27.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M230.5,46.28H224.97V43.02h15.074v3.26h-5.535V60.311h-4Z",
    transform: "translate(-144.381 -27.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M286.44,57.1v3.213H273.05V43.02h13.068v3.21h-9.092v3.754h8.028V53.1h-8.028v4Z",
    transform: "translate(-175.238 -27.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M319.32,43.02h4V57.052h8.669v3.263H319.32Z",
    transform: "translate(-204.933 -27.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M360.98,43.02h4V57.052h8.669v3.263H360.98Z",
    transform: "translate(-231.67 -27.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M410.373,56.612h-8.031l-1.53,3.69h-4.1L404.419,43h3.94L416.1,60.3h-4.2Zm-1.261-3.038-2.744-6.634-2.748,6.616Z",
    transform: "translate(-254.6 -27.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M491.262,43.02V60.315h-3.285l-8.622-10.5v10.5H475.4V43.02h3.314l8.6,10.5V43.02Z",
    transform: "translate(-305.102 -27.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M528.1,51.116c0-5.14,4-8.956,9.461-8.956s9.464,3.779,9.464,8.956-4.026,8.956-9.464,8.956-9.461-3.8-9.461-8.956m14.873,0a5.412,5.412,0,1,0-10.822,0,5.412,5.412,0,1,0,10.822,0",
    transform: "translate(-338.924 -27.057)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M589.34,43H597.2c5.656,0,9.536,3.41,9.536,8.647S602.856,60.3,597.2,60.3H589.34ZM597,57.01c3.435,0,5.685-2.049,5.685-5.373s-2.25-5.373-5.685-5.373h-3.654v10.75Z",
    transform: "translate(-378.226 -27.597)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M659.7,57.1v3.213H646.31V43.02h13.072v3.21H650.29v3.754h8.028V53.1H650.29v4Z",
    transform: "translate(-414.788 -27.609)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M61.549,15.948H37.416L32.233,0l-5.18,15.948h-14.6L29.75,0H22.575L0,20.805H47.729L17.617,44.971l-2.672,2.146-1.239,1h7.763L34.013,38.047,47.865,48.113,42.4,31.308Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4fe896ddd097378cfb2c70c4c686f5cf.svg";
export { ForwardRef as ReactComponent };